import { useEffect, useState } from "react";
import Button from "../Button/Button";
import DropdownModal from "../DropdownModal/DropdownModal";
import Select from "../Select/Select";
import {formatPrice, isMobile} from '../../services/shared';
import "./CarName.scss";

const CarName = ({car, make, model, year, modelOptions, yearOptions, trimOptions, masterCarList, allowEdit=true, editModel, cancelEdit, carChanged, openEdit})=>{

    const [newModel, setNewModel] = useState(model);
    const [newYear, setNewYear] = useState(year);
    const [newCar, setNewCar] = useState(car);


    const [newModelOptions, setNewModelOptions] = useState(modelOptions);
    const [newYearOptions, setNewYearOptions] = useState(yearOptions);
    const [newTrimOptions, setNewTrimOptions] = useState(trimOptions);
    const params = new URLSearchParams(window.location.search);

    useEffect(()=>{
        if(modelOptions.length !== newModelOptions.length){
            setNewModelOptions(modelOptions);
        } 
        if(yearOptions.length !== newYearOptions.length){
            setNewYearOptions(yearOptions);
        }
        
        if(trimOptions.length !== newTrimOptions.length){
            setNewTrimOptions(trimOptions);
        }
       
    },[modelOptions,yearOptions,trimOptions])

    useEffect(()=>{
        getYears();
        getTrims();
    },[newModel])
    useEffect(()=>{
        getTrims();
    },[newYear])


    function getYears(){
        const temp = [];
        masterCarList.filter(_=>_.model === newModel).forEach((car) => {
            const alreadyExistsIndex = temp.findIndex(_=>_.name === car.year);
            if(alreadyExistsIndex === -1){
                temp.push({
                    value: car.year,
                    name: car.year
                })
            }
        });
        setNewYearOptions(temp);
        if(temp.length){
            const found = temp.find(_=>_.name === year);
            if(found){
                setNewYear(found.name);
            }else{
                setNewYear(temp[0].name);
            }
                
        }
    }

    function getTrims(){
        const trims = masterCarList.filter(_=>_.model === newModel && _.year === newYear).map(car=>{
            return {
                value: car.titleWithPrice+'*',
                name: car.titleWithPrice+'*',
                image: car.imageUrls ? car.imageUrls[0] : null,
                oem: car.dealershipOem,
                ...car
            }
        });
        setNewTrimOptions(trims);
        
        if(trims.length){
            let defaultTrim = trims[0];
            for(let trim of trims)
                if(trim.image) {
                    defaultTrim = trim
                    break;
                }
            setNewCar(defaultTrim);
        }
    }

    const calculateEMI = () => {
        let L = 0.8;
        let Y = 6.44;
        let R = Y / 1200;
        let N = 60;
        let P = Number(car.price);
        let emi = ((P * L) *(R) * (Math.pow(1 + R, N))) / ((Math.pow(1 + R, N)) - 1);
        return Math.round(emi)
    }

    const getPriceFromTrim=(trimName)=>{
        let numberPattern = /\$\s*([\d,.]+)\*/;
        let match = trimName.match(numberPattern);
        if (match && match[1]) {
            let number = parseInt(match[1], 10);
            return number
        }
    }

    return (
        
        <div className="car-name-container">
            {/* {params.get("tmpl") === "t2" && (
                  <div className="unlock-offer">
                  <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
          <path d="M16.7547 9.50905L17.2226 9.88466L16.7547 9.50905C16.1983 10.2021 16.0345 11.1312 16.3203 11.9727L16.4256 12.283L16.9937 12.09L16.4256 12.283C16.6976 13.0839 16.2026 13.9413 15.3729 14.1063L15.0516 14.1701C14.1799 14.3434 13.4572 14.9499 13.1352 15.7782L13.0165 16.0836C12.71 16.872 11.7796 17.2106 11.0381 16.8036L10.7508 16.646C9.97175 16.2185 9.02825 16.2185 8.24915 16.646L7.96194 16.8036C7.22035 17.2106 6.29003 16.872 5.98353 16.0836L5.86483 15.7782C5.54283 14.9499 4.82006 14.3434 3.94842 14.1701L3.62709 14.1063L3.5101 14.6948L3.62709 14.1063C2.79741 13.9413 2.30239 13.0839 2.5744 12.283L2.67975 11.9727C2.96551 11.1312 2.80167 10.2021 2.24533 9.50905L2.04024 9.25357C1.51068 8.59392 1.6826 7.61893 2.40583 7.18018L2.68594 7.01025C3.44575 6.54931 3.9175 5.73221 3.93678 4.84372L3.94389 4.51618C3.96224 3.67046 4.72065 3.03408 5.5567 3.16287L5.8805 3.21275C6.75884 3.34805 7.64545 3.02535 8.23133 2.35712L8.44731 2.11077C9.00498 1.47472 9.99502 1.47472 10.5527 2.11077L10.7687 2.35712C11.3546 3.02535 12.2412 3.34805 13.1195 3.21275L13.4433 3.16287C14.2793 3.03408 15.0378 3.67047 15.0561 4.51618L15.0632 4.84372C15.0825 5.73221 15.5542 6.54931 16.3141 7.01025L16.5942 7.18018C17.3174 7.61893 17.4893 8.59392 16.9598 9.25357L16.7547 9.50905Z" stroke="white" stroke-width="1.2"/>
          <line x1="12" y1="6.84853" x2="6.84853" y2="12" stroke="white" stroke-width="1.2" stroke-linecap="round"/>
          <circle cx="12" cy="12" r="1" fill="white"/>
          <circle cx="7" cy="7" r="1" fill="white"/>
        </svg>
                    </div>
                  <div className="offer-txt">UNLOCK OFFER</div>
        
                  </div>
            )
                 
            } */}
          
            {
                editModel &&
                <DropdownModal className="model-change-dropdown">
                    <div >
                        <div className="model-change-label">Change Model</div>
                        <Select options={newModelOptions} selected={newModel} label="Model" className="mb-16px" onChange={(option)=>{
                            window.dataLayer?.push({
                                'event': 'Changed model',
                                'event_make': make,
                                'event_model': option.name,
                                'event_year': newYear,
                                'event_trim': newCar?.name
                            })
                            setNewModel(option.name);
                        }}></Select>
                        <Select options={newYearOptions} selected={newYear} label="Year"  className="mb-16px" onChange={(option)=>{
                            window.dataLayer?.push({
                                'event': 'Changed year',
                                'event_make': make,
                                'event_model': newModel,
                                'event_year': option.name,
                                'event_trim': newCar?.name
                            })
                            setNewYear(option.name);
                        }}></Select>
                        {
                            newTrimOptions.length > 0 &&
                            <Select options={newTrimOptions} selected={newCar.name} label="Trim" className="mb-16px" onChange={(option)=>{
                                window.dataLayer?.push({
                                    'event': 'Changed trim',
                                    'event_make': make,
                                    'event_model': newModel,
                                    'event_year': newYear,
                                    'event_trim': option.name
                                })
                                setNewCar(option);
                            }}></Select>
                        }
                        
                        <div className="flex">
                            <Button className="mr-8px" onClick={()=>{
                                cancelEdit();
                            }}>Cancel</Button>
                            <Button className="primary" onClick={()=>{
                                carChanged(make,newModel,newYear,newCar);
                            }}>Apply</Button>
                        </div>
                    </div>
                </DropdownModal>
            }
            <div className="flex justify-space-between" >
                {/*{params.get('tmpl') !=='t2'?<div>*/}
                {/*    <div className="car-name">{year} {make} {model} </div>*/}
                {/*    {*/}
                {/*        car?.name && <div className="car-model" >*/}
                {/*            <span className="car-trim">{car?.name?.split(' - ')[0]} </span>*/}
                {/*            <span className={`car-price strike`} style={{color:"#cb0c0c"}}>{car?.name?.split(' - ')[1]}</span>*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*</div>:<div>*/}
                {/*    <div className="car-name" style={{fontSize:"18px",lineHeight:"27px",fontWeight:"700"}}>{year} {make} {model} {*/}
                {/*        car?.name &&*/}
                {/*            <span className="car-name" style={{fontSize:"18px",lineHeight:"27px",fontWeight:"700"}}>{car?.name?.split(' - ')[0]} </span>*/}


                {/*    } </div>*/}
                {/*</div>}*/}
                <div>
                {<div className="car-name">{year} {make} {model} </div>}
         
                    {
                        car?.name && <div className="car-model"  style={(params.get('tmpl')==='t2' && window.location.pathname==="/deals" && window.innerWidth<700)?{marginBottom:"4px"}:{}}>
                            <span className="car-trim">{car?.name?.split(' - ')[0]} </span>
                            <span className={`car-price`}>{car?.name?.split(' - ')[1]}</span>
                        </div>
                    }
                </div>
                { 
                    allowEdit && <div className="model-change-cta" onClick={(e)=>{
                    e.stopPropagation();
                    setNewModel(model);
                    setNewYear(year);
                    setNewCar(car);
                    openEdit()
                    }}>CHANGE</div>

                }
                    
            </div>

{/*            {*/}
{/*                params.get('tmpl') ==='t2'&&*/}

{/*                                            car?.name && <div className="car-price-emi-container-t2">*/}
{/*                                                <p> <span className="strikethrough">${car?.price?formatPrice(getPriceFromTrim(car.name)) :'-'}*</span></p>*/}
{/*                                                    <div className="emi-container">*/}
{/*                                                    <span style={{display:"flex",flexDirection:"row",justifyContent:"flex-end",alignItems:"center"}}>*/}
{/*                                                        <p> <span className="emi-text">Est. Payment: </span><span className="emi">${calculateEMI()}/mo</span></p>*/}
{/*                                                        <span className="tooltip"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
{/*<g clip-path="url(#clip0_1266_1220)">*/}
{/*<path d="M6.50008 8.66663L6.50008 6.49996M6.50008 4.33329L6.49466 4.33329M1.08342 6.49996C1.08341 3.50842 3.50854 1.08329 6.50008 1.08329C9.49162 1.08329 11.9167 3.50842 11.9167 6.49996C11.9167 9.4915 9.49162 11.9166 6.50008 11.9166C3.50854 11.9166 1.08342 9.4915 1.08342 6.49996Z" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>*/}
{/*</g>*/}
{/*<defs>*/}
{/*<clipPath id="clip0_1266_1220">*/}
{/*<rect width="13" height="13" fill="white" transform="translate(13 13) rotate(180)"/>*/}
{/*</clipPath>*/}
{/*</defs>*/}
{/*</svg>*/}

{/*                                                           <span className="tooltiptext">This is an estimate exclusive of sales tax, title, registration and other fees. Actual payments may vary based on credit score, loan term, lender rate, down payment and trade-in value.</span>*/}

{/*                      </span>*/}

{/*                                                    </span>*/}

{/*                                                </div>*/}
{/*                                            </div>*/}


{/*            }*/}
        </div>
    )
}

export default CarName;

